/* eslint-disable import/prefer-default-export */
export const any = (arr, fn = Boolean) => arr.some(fn);
